module.exports = __webpack_public_path__ + "img/bg-content.4d7c87bf.png";